import React, { useEffect, useState } from "react";

const DeviceRestriction: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileDevice =
      /android|iphone|ipad|ipod|windows phone|mobile|tablet/.test(userAgent) ||
      window.innerWidth < 768; // Adjust width as per your design
    setIsMobile(isMobileDevice);
  }, []);

  if (isMobile) {
    return (
      <div
        style={{
          //   display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "calc(100vh - 60px)",
          textAlign: "center",
          backgroundColor: "#f8d7da",
          color: "#721c24",
          fontSize: "1.5rem",
          padding: "1rem",
          zIndex: "999",
          position: "fixed",
          width: "100%",
        }}
        className="resize"
      >
        This application can only be used on a desktop browser.
      </div>
    );
  }

  return null; // Render nothing if not on mobile
};

export default DeviceRestriction;
